// extracted by mini-css-extract-plugin
export default {"back-button":"BackButton-module__back-button--Jgcaf"};